import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: ${props => (props.showError ? 'block' : 'none')}
  height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: normal;
  color: #ff2600;
`

export const ErrorContainer = ({errorMessage}) => (
  <Wrapper showError={errorMessage}>{errorMessage}</Wrapper>
)

export default ErrorContainer
